// Pushes the signed-in account into the Chronicle plugin. The BLE actor
// resolves a binding code and a reconnect target on paths with no frontend
// involvement (monitor loop, macOS parked connect, Windows watcher sighting),
// so it cannot ask for them when it needs them.
import { isTauri } from '@/tauri/utils';

export async function setChronicleActiveUser(userRefId: string | null): Promise<void> {
  if (!isTauri()) return;
  const { invoke } = await import('@tauri-apps/api/core');
  await invoke<void>('chronicle_set_active_user', { userRefId });
}
